import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// Material imports
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import HelpIcon from "@limitless/icons/QuestionCircle";
import Button from "@limitless/modern/inputs/button/Button";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import Grid from "@limitless/modern/layout/Grid";
// Limitless imports
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import { useExpertProfileContext } from "../../../../expert";
import CloseIcon from "@limitless/icons/Close";
const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 12,
    width: 370,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    background: "#FFFFFF",
    boxShadow: "0px 1px 6px -3px rgba(0, 0, 0, 0.75)",
    marginRight: props => props && props.clientWidth - props.offsetLeft - 58
  },
  description: {
    lineHeight: "23px",
    marginTop: 8
  },
  close: {
    color: "#0A2267",
    fontSize: 18,
    padding: "0 8px",
    minWidth: "auto",
    marginTop: -8,
    marginRight: -8,
    marginBottom: 8
  },
  okButton: {
    minWidth: 120
  },
  overlay: {
    position: "fixed",
    display: "block",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 2
  },
  overButton: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    width: 48,
    height: 36,
    left: props => props && props.offsetLeft - 12,
    top: props => props && props.offsetTop - 6,
    borderRadius: 6
  }
}));
const validPaths = ["/tasklist", "/onboarding"];
const HelpHighlightPopper = ({
  buttonRef
}) => {
  const [open, setOpen] = React.useState(true);
  const {
    profile,
    saveProfile
  } = useExpertProfileContext();
  const [reference, setReference] = React.useState(buttonRef);
  const theme = useTheme();
  const location = useLocation();
  const correctPath = validPaths.includes(location.pathname);
  React.useEffect(() => {
    setReference(buttonRef);
  }, [buttonRef]);
  const updateProfile = () => {
    const profile = {
      hasSeenWebGuide: true
    };
    saveProfile(profile);
    setOpen(false);
  };
  const onOkClick = () => {
    updateProfile();
  };
  const onCloseClick = () => {
    updateProfile();
  };
  const classProps = reference ? {
    offsetTop: reference.offsetTop,
    offsetLeft: reference.offsetLeft,
    clientWidth: reference.ownerDocument.documentElement.clientWidth
  } : {};
  const classes = useStyles(classProps);
  return !(profile !== null && profile !== void 0 && profile.hasSeenWebGuide) && profile.helpGuideAvailable && correctPath && /*#__PURE__*/React.createElement("div", {
    className: open ? classes.overlay : null
  }, open && /*#__PURE__*/React.createElement("div", {
    className: classes.overButton
  }, /*#__PURE__*/React.createElement(HelpIcon, {
    style: {
      color: theme.palette.primary.main,
      position: "absolute",
      top: 6,
      left: 12
    }
  })), reference && /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: reference,
    placement: "bottom",
    keepMounted: true,
    disablePortal: true,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 0]
      }
    }],
    sx: {
      position: "relative",
      padding: theme => `${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(3)} ${theme.spacing(3)}`
    }
  }, " ", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onCloseClick,
    icon: /*#__PURE__*/React.createElement(CloseIcon, null),
    sx: {
      position: "absolute",
      top: 24,
      right: classProps.clientWidth - classProps.offsetLeft - 42,
      color: theme => theme.palette.grey[2]
    },
    label: "Close Button"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, "HELP AND TUTORIALS")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: classes.description
  }, "Need help getting around? Select Open Limitless Guide from the", /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      width: 23,
      display: "inline-block",
      margin: "0 5px"
    }
  }, /*#__PURE__*/React.createElement(HelpIcon, {
    style: {
      color: theme.palette.primary.main,
      position: "absolute",
      bottom: "-8px"
    }
  })), "menu")), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    sx: {
      marginTop: 2
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onOkClick,
    color: "secondary",
    variant: "contained",
    className: classes.okButton
  }, "OK"))))));
};
HelpHighlightPopper.propTypes = {
  buttonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
export default HelpHighlightPopper;